import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {tap} from 'rxjs/operators';


@Injectable({
  providedIn: "root"
})
export class SnackBarService {

  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService) {

  }

  i18nMessage(i18nCode:string, params: Object = {}, config: MatSnackBarConfig = {duration: 3000}) {
    this.translate.get(i18nCode, params)
      .pipe(
        tap(message => this.snackBar.open(message, 'Close', config))
      )
      .subscribe();
    ;
  }

}
